export default "__VITE_ASSET__Ue_Wif_b__"